import { render, staticRenderFns } from "./ManageIncidentType.vue?vue&type=template&id=0a4e5bcd&scoped=true"
import script from "./ManageIncidentType.vue?vue&type=script&lang=js"
export * from "./ManageIncidentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4e5bcd",
  null
  
)

export default component.exports